import { render, staticRenderFns } from "./ScoopRating.vue?vue&type=template&id=8f68ea78&scoped=true&"
import script from "./ScoopRating.vue?vue&type=script&lang=js&"
export * from "./ScoopRating.vue?vue&type=script&lang=js&"
import style0 from "./ScoopRating.vue?vue&type=style&index=0&id=8f68ea78&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f68ea78",
  null
  
)

export default component.exports